import React from 'react';
import '../../../assets/fonts/fonts.css';
import Sidebar from '../sidebar/Sidebar';
import './Layout.css';

class Layout extends React.Component {
  render() {
    const { match } = this.props
    return (
      <div className="container-global">
        {match.path != "/orderServiceView/:id" ?
          <Sidebar />
          : <div />
        }
        <div className="container-global-right">
          <div className="marginTopChildrenGlobal">{this.props.children}</div>
        </div>
      </div>
    )
  }
}

export default Layout



// WEBPACK FOOTER //
// ./src/shared/component/layout/Layout.jsx